var objectToString = {}.toString;
var DATE_STRING = "[object Date]";

export default function isDate(value) {
    return objectToString.call(value) === DATE_STRING;
}
//# sourceMappingURL=is-date.js.map



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@telerik/kendo-intl/dist/es/common/is-date.js
// module id = ../../../../@telerik/kendo-intl/dist/es/common/is-date.js
// module chunks = 3